import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Logo from "../assets/logo.png";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import Alert from "@mui/material/Alert";
import Divider from "@mui/material/Divider";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import { useState } from "react";
import { setAuditar } from "../componentes/api.js";
import FormControl from "@mui/material/FormControl";
import DoneIcon from "@mui/icons-material/Done";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";

function Evaluar({ show, handleClose, id, idUsuario, consultarDatos }) {
  const [detalle, setDetalle] = useState("");
  const tab = <>&nbsp;&nbsp;&nbsp;&nbsp;</>;

  const calificar = async (event, estado) => {
    event.preventDefault();
    if (detalle === "") {
      alert("Por favor digite un Detalle!");
    } else {
      try {
        await setAuditar({
          id: id,
          estado: estado,
          idUsuario: idUsuario,
          motivoEstado: detalle,
        });
        alert("Actividad Realizada!");
      } catch (error) {
        alert(["Ocurrio un error al Calificar", error]);
      }
    }
  };

  const salir = () => {
    handleClose();
    consultarDatos();
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <img
            src={Logo}
            className="img-fluid"
            width="80px"
            height="80px"
            alt="logo"
          />
          <Modal.Title> {tab} EVALUADOR DE ACTIVIDADES</Modal.Title>
        </Modal.Header>
        <form method="post" encType="multipart/form-data">
          <Modal.Body>
            <Stack sx={{ width: "100%" }} spacing={2}>
              <Alert severity="success">
                <strong>
                  Califique o devuelva según criterio de Política empresarial!
                </strong>
              </Alert>
            </Stack>

            <FormControl fullWidth sx={{ m: 1 }}>
              <InputLabel htmlFor="detalle">Detalle</InputLabel>
              <OutlinedInput
                multiline
                name="detalle"
                label="Descripción de la evaluación"
                onChange={(event) => {
                  setDetalle(event.target.value);
                }}
              />
            </FormControl>

            <Stack direction="row" spacing={1}>
              <Chip
                label="Vo.Bo."
                color="primary"
                onClick={(event) => calificar(event, "3")}
                onDelete={(event) => calificar(event, "3")}
                deleteIcon={<DoneIcon />}
              />

              <Chip
                label="Devolver"
                color="secondary"
                onClick={(event) => calificar(event, "2")}
                onDelete={(event) => calificar(event, "2")}
                deleteIcon={<ThumbDownOffAltIcon />}
                variant="outlined"
              />
            </Stack>

            <Divider light className="mt-1 mb-1" />

            <Modal.Footer>
              <Button variant="secondary" onClick={salir}>
                Salir
              </Button>
            </Modal.Footer>
          </Modal.Body>
        </form>
      </Modal>
    </>
  );
}
export default Evaluar;
